// @flow

// export const strings = {
//   intro: "Hi",
//   "result.great": "Great",
//   "result.good": "Great",
//   "result.notgood": "Not good",
//   "result.terrible": "Terrible!",
//   "button.start": "Take the quiz",
//   "button.submit": "Submit",
//   "button.next": "Next question",
//   "button.reset": "Start again",
//   "button.sharetwitter": "Share on Twitter",
//   "button.sharetfacebook": "Share on Facebook",
//   "button.signup": "Sign up to stay informed"
// };

type IntroStep = {
  +id: string,
  +type: "intro",
  +title: string,
  +text: string,
  +nextStep: string
};

type OutroStep = {
  +id: string,
  +type: "outro",
  +text: string,
  +nextStep: string
};

export type QuestionStep = {
  +id: string,
  +type: "question",
  +step: number,
  +question: string,
  +answerValue: number,
  +nextStep: string
};

export type Step = IntroStep | OutroStep | QuestionStep;

export type Steps = { +[id: string]: Step };

export const questions: Array<QuestionStep> = [
  {
    id: "q1",
    step: 1,
    type: "question",
    question:
      "set “doing good for society” as one of their long-term professional goals?",
    answerValue: 66,
    nextStep: "q2"
  },
  {
    id: "q2",
    step: 2,
    type: "question",
    question:
      "think they have influence at work to make a positive social impact?",
    answerValue: 48,
    nextStep: "q3"
  },
  {
    id: "q3",
    step: 3,
    type: "question",
    question:
      "think they can use their financial resources to make a positive social impact?",
    answerValue: 46,
    nextStep: "q4"
  },
  {
    id: "q4",
    step: 4,
    type: "question",
    question:
      "prefer to save cash rather than make financial investments in order to meet their long-term goals?",
    answerValue: 33,
    nextStep: "q5"
  },
  {
    id: "q5",
    step: 5,
    type: "question",
    question:
      "think it’s difficult to make money on investments, while also doing good for society?",
    answerValue: 32,
    nextStep: "q6"
  },
  {
    id: "q6",
    step: 6,
    type: "question",
    question:
      "think the potential benefits of making financial investments with positive social impact exceed the potential costs?",
    answerValue: 40,
    nextStep: "q7"
  },
  {
    id: "q7",
    step: 7,
    type: "question",
    question:
      "think that the right investment strategy for them is very different from their parents’ one?",
    answerValue: 64,
    nextStep: "q8"
  },
  {
    id: "q8",
    step: 8,
    type: "question",
    question: "think they’ll switch jobs more frequently than their parents?",
    answerValue: 69,
    nextStep: "q9"
  },
  {
    id: "q9",
    step: 9,
    type: "question",
    question:
      "think they’ll have to retire at a later stage in life than their parents?",
    answerValue: 60,
    nextStep: "outro"
  }
];

export const steps: Steps = {
  intro: {
    id: "intro",
    type: "intro",
    title: "Do you think like a “millennial”?",
    text:
      "The millennial generation is fast becoming a major force in the world economy. Their varied tastes and evolving demands are influencing other generations too. The potential implications are big for everyone. So how well do you know the millennials?",
    nextStep: "q1"
  },
  q1: questions[0],
  q2: questions[1],
  q3: questions[2],
  q4: questions[3],
  q5: questions[4],
  q6: questions[5],
  q7: questions[6],
  q8: questions[7],
  q9: questions[8],
  outro: {
    id: "outro",
    type: "outro",
    text: "You achieved a score of",
    nextStep: "intro"
  }
};



// WEBPACK FOOTER //
// ./src/data/quizData.js